(function ($, Drupal) {
  Drupal.behaviors.collapseAccordionsBtn = {
    attach: function registerAccordionBtn(context) {
      window.ranTimes = window.ranTimes ++;
      context = context || document;
      // check for body fields with accordions
      var bodyField = context.querySelector('.field--name-body');
      // CKeditor5 doesn't have the accordion class on the details.
      bodyField.querySelectorAll('details').forEach((d) => d.classList.add('accordion'));
      if (bodyField && bodyField.querySelector('.accordion')) {
        // var collapseButton = $(`
        //   <div class="expandButtonWrapper">
        //     <button class="expandAccordionsBtn" type="toggle" onclick="collapseAccordions(this)" visibility="hidden">
        //       <span class="closeIcon">
        //         <svg xmlns="http://www.w3.org/2000/svg" fill="#921931" width="15.556" height="15.556" viewBox="0 0 15.556 15.556">
        //           <g id="icon-close-thin" transform="translate(7.778 -6.364) rotate(45)">
        //             <rect id="Rectangle" width="2" height="20" transform="translate(9)"/>
        //             <rect id="Rectangle-2" data-name="Rectangle" width="2" height="20" transform="translate(20 9) rotate(90)"/>
        //           </g>
        //         </svg>
        //       </span>
        //       <label> Collapse All</label>
        //     </button>
        //   </div>
        // `);

        // Wrapping each grouping of adjacent .accordion elements with a container element
        var collection = [];
        $('.field--name-body .accordion').each(function() {
            var nextBox = $(this).next().hasClass('accordion');

            collection.push($(this));

            if(!nextBox)
            {
                var container = $('<div class="accordion-container"></div>');
                container.insertBefore(collection[0]);
                for(var i = 0; i < collection.length; i++)
                {
                    collection[i].appendTo(container);
                }
                collection = [];
            }
        })

        // Inserting a collapse button before each .accordion-container
        // $(collapseButton).insertBefore($('.field--name-body .accordion-container'));

        // Showing or hiding collapse button depending on if all accordions are closed or not
        $('.field--name-body .accordion').on('click', function() {
          setTimeout(() => {
            var accordionContainer = $(this).parent();
            //var expandButtonContainer = $(accordionContainer).prev();

            var accordions = $(accordionContainer).find('.accordion');
            var stayOpen = false;
            $(accordions).each(function() {
              if ($(this)[0].hasAttribute('open')) {
                stayOpen = true;
                return false;
              }
            });

            // if (!stayOpen) {
            //   $(expandButtonContainer).find('.expandAccordionsBtn').removeClass('visible');
            // }
            // else {
            //   $(expandButtonContainer).find('.expandAccordionsBtn').addClass('visible');
            // }
          }, 250);
        });

        // Close all .accordion in the adjacent .accordion-container to the collape button clicked
        if (!window.collapseAccordions) {
          window.collapseAccordions = function collapseAccordions(element) {
            $(element).removeClass('visible');
            $(element).parent().next().find('.accordion').each(function() {
              $(this).removeAttr('open');
            });
          }
        }
      }
    }
  }
})(jQuery, Drupal);


(function ($, Drupal) {
  Drupal.behaviors.collapseAccordionsBtn2 = {
    attach: function registerAccordionBtn2(context) {
      window.ranTimes = window.ranTimes++;
      context = context || document;
      // check for body fields with accordions
      var bodyField = context.querySelector(".block--main-page-content");
      // CKeditor5 doesn't have the accordion class on the details.
      bodyField
        .querySelectorAll("details")
        .forEach((d) => {
          if (!d.classList.contains("horizontal-tabs-pane")) {
            d.classList.add("accordion")
          }
        });
    },
  };
})(jQuery, Drupal);
